<template>
    <div>
        <confirm ref="confirm" />
        <confirm-delete ref="confirmDelete" />
        <erp-data-dialog ref="erpDataDialog" />
        <plan-selection
            ref="changePlan"
            @modelChanged="$emit('modelChanged')"
        />
        <request-cancellation ref="requestCancellation" />
    </div>
</template>

<script>
import Confirm from '@/shared/components/Confirm'
import ConfirmDelete from '@/shared/components/ConfirmDelete'
import ErpDataDialog from '@/shared/components/ErpDataDialog'
import PlanSelection from '@/components/plans/PlanSelectionV3'
import RequestCancellation from './RequestCancellation'

export default {
    components: {
        Confirm,
        ConfirmDelete,
        ErpDataDialog,
        PlanSelection,
        RequestCancellation,
    },

    data() {
        return {
            confirmText: undefined,
        }
    },

    methods: {
        async showErpData(model) {
            this.$refs.erpDataDialog.open(model.erp_data)
        },

        async changePlan(model) {
            this.$refs.changePlan.open(model)
        },

        async block(model) {
            let confirm = await this.$refs.confirm.open(
                this.$t('dialogs.customer.block.title'),
                this.$t('dialogs.customer.block.text', {
                    name: model.trade_name,
                }),
            )

            if (!confirm) return

            model.block().then(res => {
                if (!res) return
                this.$emit('modelChanged', res)
                let feedback = this.$t('dialogs.customer.block.success', {
                    name: model.trade_name,
                })
                this.$bus.$emit('notify', 'success', feedback)
            })
        },

        async unblock(model) {
            let confirm = await this.$refs.confirm.open(
                this.$t('dialogs.customer.unblock.title'),
                this.$t('dialogs.customer.unblock.text', {
                    name: model.trade_name,
                }),
            )

            if (!confirm) return

            model.unblock().then(res => {
                if (!res) return
                this.$emit('modelChanged', res)
                let feedback = this.$t('dialogs.customer.unblock.success', {
                    name: model.trade_name,
                })
                this.$bus.$emit('notify', 'success', feedback)
            })
        },

        async requestCancellation(model) {
            let requested = await this.$refs.requestCancellation.open(model)
            if (requested) {
                this.$emit('modelChanged')
            }
        },

        async delete(model) {
            let confirmed = await this.$refs.confirmDelete.confirm(
                model.trade_name,
            )
            if (!confirmed) return

            if (!(await model.delete())) return

            this.$emit('modelChanged')
            this.$bus.$emit(
                'notify',
                'success',
                this.$t('resources.feedbacks.success.delete', {
                    resource: this.$tc('resources.customer.name', 1),
                }),
            )
        },

        createProposal(model) {
            this.$router.push({
                name: 'plan-proposal.create',
                params: { customer_id: model.id },
            })
        },
    },
}
</script>

<style></style>
